export const API_KEY = "1888761-41f12aec6f7b50c314bb89730";
export const BASE_URL = "https://pixabay.com/api/";
